import { TripOutput } from '@allocab/allocab-passenger-shared-types';

import cancelledImage from '../../../assets/images/watch-cancelled-light.svg';
import { t } from '../../../services/translation/translation';
import { formatDateForParisTZ } from '../../../utils/date';

interface Props {
  trip: TripOutput;
}

export const Cancelled = ({ trip }: Props) => {
  const cancelledAt = trip.resume.history?.cancelledAt;
  return (
    <div className="flex justify-between items-center gap-x-2">
      <div className="flex-col flex w-full">
        <strong>{t('share-route.trip-detail.trip-cancelled')}</strong>
        {cancelledAt ? (
          <span>{formatDateForParisTZ(cancelledAt, t('share-route.trip-detail.datetime-full'))}</span>
        ) : null}
      </div>
      <img alt="cancel" src={cancelledImage} />
    </div>
  );
};
